export default __webpack_public_path__ + "static/media/error403.6fb2f28c.svg";